import React from 'react'
import { Link } from 'react-router'
import Container from 'muicss/lib/react/container'
import CategoryList from '../containers/CategoryList'
import FeaturedList from './FeaturedList'

const Home = ({ featuredLists }) => (
  <div>
      <div className="home-header">
          <h1><span>Catalog</span> by SELECTS</h1>
      </div>
      <Container>
          <h3 className="section-title">カテゴリから探す</h3>
          <div className="divider"></div>
          <CategoryList />
          {/*
          <h3 className="section-title">特集から探す</h3>
          <div className="divider"></div>
          <FeaturedList items={featuredLists} />
          */}
      </Container>
  </div>
)

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.jsx